<template>
    <div>
      <!-- Add Modal -->
      <b-modal
        v-model="showAddModal"
        title="Add Asset"
        id="addModal"
        ok-title="Submit"
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group label="Serial Number">
                <b-form-input required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Name">
                <b-form-input required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Amount">
                <b-form-input required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Purchase Date">
                <flat-pickr v-model="dateDefault" class="form-control" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Description">
                <b-form-textarea required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Category">
                <v-select
                  v-model="selectedCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionCategory"
                  label="title"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Status">
                <v-select
                  v-model="selectedStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionStatus"
                  label="title"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <!-- View Modal -->
  
      <b-modal
        v-model="showViewModal"
        title="View Asset"
        id="viewModal"
        @hidden="resetViewModal"
      >
        <div v-if="selectedRow">
          <p><strong>Serial Number: </strong>{{ selectedRow.serialNum }}</p>
          <p><strong>Name: </strong>{{ selectedRow.name }}</p>
          <p><strong>Purchase Date: </strong>{{ selectedRow.amount }}</p>
          <p><strong>Amount: </strong>{{ selectedRow.purchaseDate }}</p>
          <p><strong>Description: </strong>{{ selectedRow.description }}</p>
          <p><strong>Category: </strong>{{ selectedRow.category }}</p>
          <p>
            <strong>Status: </strong
            ><b-badge :variant="selectedRow.status.variant" pill>{{
              selectedRow.status.name
            }}</b-badge>
          </p>
        </div>
      </b-modal>
      <!-- Edit Modal -->
      <b-modal
        v-model="showEditModal"
        title="Edit Asset"
        id="editModal"
        ok-title="Submit"
      >
        <div v-if="selectedRow">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group label="Serial Number">
                  <b-form-input
                    v-model="selectedRow.serialNum"
                    required
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Name">
                  <b-form-input v-model="selectedRow.name" required />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Amount">
                  <b-form-input v-model="selectedRow.amount" required />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Purchase Date">
                  <flat-pickr
                    v-model="selectedRow.purchaseDate"
                    class="form-control"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Description">
                  <b-form-textarea v-model="selectedRow.description" required />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Category">
                  <v-select
                    v-model="selectedRow.category"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionCategory"
                    label="title"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Status">
                  <v-select
                    v-model="selectedRow.status.name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionStatus"
                    label="title"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-modal>
  
      <b-row class="justify-content-end">
        <b-col md="3" class="my-1">
        <SearchBar placeholder="Search ..."></SearchBar>
      </b-col>
        <b-col md="2" cols="6" class="my-md-1">
          <b-form-group class="mb-0 my-auto">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select id="perPageSelect" size="sm" class="w-50" />
          </b-form-group>
        </b-col>
  
        <b-col md="1" cols="6" class="my-md-1">
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              v-b-tooltip.hover="'Add Asset'"
              variant="primary"
              class="btn-icon"
              @click="openAddModal('addModal')"
              size="sm"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-table striped :items="tableData" :fields="tableFields" responsive>
        <!-- Status column -->
        <template #cell(status)="row">
          <b-badge pill :variant="row.value.variant">
            {{ row.value.name }}
          </b-badge>
        </template>
        <!-- Actions column using #cell() slot -->
        <template #cell(actions)="row">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="text-body align-middle mr-25"
              />
            </template>
            <b-dropdown-item @click="viewItem(row.item)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item @click="editItem(row.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deleteItem(row.item)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
  </template>
  
  <script>
  import {
    BTable,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,
    BModal,
    VBModal,
    VBTooltip,
    BRow,
    BCol,
    BFormCheckbox,
    BForm,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BFormSelect,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import SearchBar from "@/components/search-component/SearchBar.vue";
  import flatPickr from "vue-flatpickr-component";
  export default {
    components: {
      BTable,
      BButton,
      BBadge,
      BDropdown,
      BDropdownItem,
      BModal,
      BRow,
      BCol,
      BFormCheckbox,
      BForm,
      BInputGroup,
      BInputGroupAppend,
      BFormInput,
      BFormTextarea,
      BFormGroup,
      BFormSelect,
      vSelect,
      flatPickr,SearchBar
    },
    directives: {
      "b-tooltip": VBTooltip,
      "b-modal": VBModal,
    },
    data() {
      return {
        showEditModal: false,
        selectedRow: null,
        showViewModal: false,
        selectedStatus: null,
        optionStatus: [{ title: "Active" }, { title: "Inactive" }],
        selectedCategory: null,
        optionCategory: [{ title: "Category A" }, { title: "Category B" }],
        dateDefault: null,
        showAddModal: false,
        tableFields: [
          { key: "serialNum", label: "Serial Num" },
          { key: "name", label: "Name" },
  
          { key: "purchaseDate", label: "Purchase Date" },
          { key: "amount", label: "Amount" },
          { key: "description", label: "Description" },
          { key: "category", label: "Category" },
          { key: "status", label: "Status" },
          { key: "actions", label: "Actions" },
        ],
        tableData: [
          {
            name: "Item 1",
            serialNum: "12345",
            purchaseDate: "2022-01-01",
            amount: 100,
            description: "Lorem ipsum dolor sit amet",
            category: "Category A",
            status: { name: "Active", variant: "success" },
          },
          {
            name: "Item 2",
            serialNum: "67890",
            purchaseDate: "2022-02-01",
            amount: 200,
            description: "Consectetur adipiscing elit",
            category: "Category B",
            status: { name: "Inactive", variant: "danger" },
          },
        ],
      };
    },
    methods: {
      openAddModal(modalId) {
        this.showAddModal = true;
      },
      editItem(item) {
        this.selectedRow = { ...item }; // Create a copy of the item to avoid modifying the original data
        this.showEditModal = true;
      },
  
      viewItem(item) {
        this.selectedRow = item;
        this.showViewModal = true;
      },
      resetViewModal() {
        this.selectedRow = null;
      },
  
      deleteItem(item) {
        // Handle delete action for the selected item
        console.log("Delete item:", item);
      },
    },
  };
  </script>
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  </style>